import { defineStore } from "pinia";

export const useOptionStore = defineStore("option", {
  state: (): {
    unitSystem: "metric" | "imperial";
  } => ({
    unitSystem: "metric",
  }),
  getters: {
    isMetricUnit: (state) => {
      return state.unitSystem === "metric";
    },
  },
  actions: {
    changeUnitSystem() {
      if (this.$state.unitSystem === "metric") {
        this.$state.unitSystem = "imperial";
      } else {
        this.$state.unitSystem = "metric";
      }
    },
  },
});
